import {createContext, PropsWithChildren, useMemo, useState} from "react";
import {useReload} from "../hardware/ReloadContext";
import {Keying2PendingItem, Keying2Shortcode} from "../../../../api/Keying2";

export type EditInfo = {
    id: number;
    defaultValue?: Keying2Shortcode;
    add?: Keying2PendingItem;
}

export const KeyingEditingContext = createContext({
    editing: null as EditInfo | null,
    onEdit: (info: EditInfo): void => {throw new Error("no provider")},
    onDone: (): void => {throw new Error("no provider")},
});

export function KeyingEditingContextProvider(props: PropsWithChildren<{}>) {
    const [editing, setEditing] = useState<EditInfo | null>(null);

    useReload(() => {
        setEditing(null);
    }, []);

    const ctx = useMemo(() => ({
        editing,
        onEdit: (info: EditInfo) => setEditing(info),
        onDone: () => setEditing(null),
    }), [editing]);

    return (
        <KeyingEditingContext.Provider value={ctx}>
            {props.children}
        </KeyingEditingContext.Provider>
    );
}
